import React from "react";
import { NavLink } from "react-router-dom";

const PropsList = ({ taskStatuses, filmId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Task Statuses</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/task-statuses/order`}
            activeClassName="is-active">
            Order
          </NavLink>
        </li>
        <hr />

        {taskStatuses?.map((taskStatus, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/task-statuses/${taskStatus.id}/edit`}
                title={taskStatus.name}
                activeClassName="is-active"
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/task-statuses/${taskStatus.id}`
                  );
                }}>
                {taskStatus.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default PropsList;
